import { Component, OnInit, Output,Input ,EventEmitter  } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import { Persona } from '../../../models/Persona';
import { LoginService } from 'app/services/login/login.service';
import { SecurityService } from '../../../services/security/security.service';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { LiquidacionService } from '../../../services/liquidacion/liquidacion.service';
import { environment } from 'environments/environment';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
declare var $: any;
@Component({
  selector: 'app-nuevo-contacto',
  templateUrl: './nuevo-contacto.component.html',
  styleUrls: ['./nuevo-contacto.component.scss'],
  providers:[Persona,MessagesTitles, MessagesStatus,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ]
})
export class NuevoContactoComponent implements OnInit {
  Id_Tipo_DNI=environment.ID_TIPO_DNI;
  Id_Carnet=environment.ID_CARNET;
  @Input() IdContacto : string;
  @Output() cerrarAgregarContacto: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<boolean>();

  loading: boolean = false;
  disable: boolean = false;
  isLinear: boolean = false;

  user: any;
  doc: string = '0';
  tipoDocumentoElement: number;
  idEmpresa: number = 0;
  Titulo: string;
  razSocial: string;
  editar: boolean;
  persona: Persona;
  rolContactoElement: any ;
  tipoContactoElement: any;
  dataContacto : any = [];

  formularioContacto: FormGroup;
  bodyObtenerPersona: any = {
    'Tipo_Documento_Identidad': 'D',
    'NroDoc': ''
  }

  constructor(
    private empresasService : EmpresasService , 
     private liquidacionService : LiquidacionService,
     private routerActive:ActivatedRoute,
     private msgTitulos : MessagesTitles,
     private msgStatus:MessagesStatus,
     private loginService:LoginService,private securityService: SecurityService,) {

    this.cerrarAgregarContacto = new EventEmitter();
    this.loginService.clickGuard = true;
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.Titulo = "Nuevo Contacto";
     
   if (this.liquidacionService.addContactoLiquidacion) {
      this.razSocial = liquidacionService.proveedorCorreo.pNomComercial;
      this.idEmpresa = liquidacionService.proveedorCorreo.idProveedor;
      this.liquidacionService.addContactoLiquidacion = false;
   } else if (this.empresasService.pagareDatos) {
      if(!this.empresasService.pagareDatos.idAval){
        this.idEmpresa = this.empresasService.pagareDatos.idEmpresa; 
        this.razSocial = this.empresasService.pagareDatos.Razon_Social;
      }else{
        this.idEmpresa = this.empresasService.pagareDatos.idAval; 
        this.razSocial = this.empresasService.pagareDatos.Razon_SocialAval;
      }
   } else {
      this.razSocial = sessionStorage.getItem('razSocial');
      this.routerActive.params.subscribe( 
        params => {
          this.idEmpresa = params['id']; 
        }
      )
    }

    this.formularioContacto = new FormGroup({
      "docExiste" :new FormControl('1',[]),
      "idEmpresas":new FormControl(this.idEmpresa,  Validators.required),
      "Tipo_Documento_Identidad": new FormControl(this.Id_Tipo_DNI,  Validators.required),
      "Nombre_de_Contacto": new FormControl('',  Validators.required),
      "Nro_Documento_Identidad": new FormControl('',  Validators.required),
      "Apellido_Paterno": new FormControl('',  Validators.required),
      "Apellido_Materno":new FormControl('',  Validators.required),
      "Nombre1":new FormControl('',  Validators.required),
      "Nombre2": new FormControl('',  Validators.required),
      "NroMovil_Laboral": new FormControl(''),
      "NroFijo_Laboral":new FormControl(''),
      "Anexo":new FormControl(''),
      "Correo": new FormControl('',  Validators.required),
      "Direccion":new FormControl(''),
      "Distrito":new FormControl('',),
      "Sexo":new FormControl('M',),
      "Tipo_de_Contacto": new FormControl(this.tipoContactoElement,  Validators.required),
      "Rol_del_Contacto":new FormControl(this.rolContactoElement,  Validators.required),
      "Condicion":new FormControl('3',  Validators.required),
      "Contrasena":new FormControl(null),
      "Fecha_Contrasena": new FormControl(null),
      "Adjunto_Vigencia_Poder": new FormControl(null),
      "Adjunto_DNI":new FormControl(null),
      "Fecha_Adjuntos":new FormControl(null),
      "Usuario": new FormControl(this.user.Usuario),
      "Campo_1": new FormControl(''),
      "Campo_2": new FormControl(''),
      "Campo_3": new FormControl(''),
      "Campo_4": new FormControl(''),
      "Campo_5": new FormControl(''),
      "Campo_6": new FormControl(''),
      "Campo_7": new FormControl(''),
      "Campo_8": new FormControl(''),
      "Campo_9": new FormControl(''),
      "Campo_10": new FormControl(''),
      "Campo_11": new FormControl('nombramiento'),
      "Campo_12": new FormControl(''),
      "Campo_13": new FormControl(''),
      "Campo_14": new FormControl(''),
      "Campo_15": new FormControl(''),
      "Campo_16": new FormControl(''),
      "Campo_17": new FormControl(''),
      "Campo_18": new FormControl(''),
      "checkCreateUser": new FormControl(0)
    });
  }

  ngOnInit() {
    this.validarDocumentoExiste(this.doc);

    if(this.IdContacto != "" && this.IdContacto != undefined ){
      this.loading = true;
      this.Titulo = "Editar Contacto";
      this.editar = true;
      this.empresasService.obtenerContacto(this.IdContacto)
      .subscribe(res => {     

        this.dataContacto = res;     
        this.formularioContacto.controls['Tipo_Documento_Identidad'].setValue(this.dataContacto.Persona.Tipo_Documento_Identidad);  
        this.formularioContacto.controls['Nro_Documento_Identidad'].setValue(this.dataContacto.Persona.Nro_Documento_Identidad);      
        this.formularioContacto.controls['Nro_Documento_Identidad'].disable();
        this.formularioContacto.controls['Nombre1'].setValue(this.dataContacto.Persona.Nombre1);
        this.formularioContacto.controls['Nombre1'].enable();
        this.formularioContacto.controls['Nombre2'].setValue(this.dataContacto.Persona.Nombre2);
        this.formularioContacto.controls['Nombre2'].enable();
        this.formularioContacto.controls['Apellido_Paterno'].setValue(this.dataContacto.Persona.Apellido_Paterno);
        this.formularioContacto.controls['Apellido_Paterno'].enable();
        this.formularioContacto.controls['Apellido_Materno'].setValue(this.dataContacto.Persona.Apellido_Materno);
        this.formularioContacto.controls['Apellido_Materno'].enable();
        this.formularioContacto.controls['Direccion'].setValue(this.dataContacto.Persona.Direccion);
        this.formularioContacto.controls['Distrito'].setValue(this.dataContacto.Persona.Distrito);
        this.formularioContacto.controls['Sexo'].setValue(this.dataContacto.Persona.Sexo);
        this.formularioContacto.controls['NroMovil_Laboral'].setValue(this.dataContacto.NroMovil_Laboral);
        this.formularioContacto.controls['Correo'].setValue(this.dataContacto.Correo);   
        this.formularioContacto.controls['NroFijo_Laboral'].setValue(this.dataContacto.NroFijo_Laboral);  
        this.formularioContacto.controls['Rol_del_Contacto'].setValue(this.dataContacto.Rol_del_Contacto);  
        this.formularioContacto.controls['Anexo'].setValue(this.dataContacto.Anexo);  
        this.formularioContacto.controls['Tipo_de_Contacto'].setValue(this.dataContacto.Tipo_de_Contacto); 
        this.formularioContacto.controls['Campo_1'].setValue(this.dataContacto.Campo_1); 
        this.formularioContacto.controls['Campo_2'].setValue(this.dataContacto.Campo_2); 
        this.formularioContacto.controls['Campo_3'].setValue(this.dataContacto.Campo_3); 
        this.formularioContacto.controls['Campo_4'].setValue(this.dataContacto.Campo_4); 
        this.formularioContacto.controls['Campo_5'].setValue(this.dataContacto.Campo_5); 
        this.formularioContacto.controls['Campo_6'].setValue(this.dataContacto.Campo_6); 
        this.formularioContacto.controls['Campo_7'].setValue(this.dataContacto.Campo_7); 
        this.formularioContacto.controls['Campo_8'].setValue(this.dataContacto.Campo_8); 
        this.formularioContacto.controls['Campo_9'].setValue(this.dataContacto.Campo_9); 
        this.formularioContacto.controls['Campo_10'].setValue(this.dataContacto.Campo_10); 
        this.formularioContacto.controls['Campo_11'].setValue(this.dataContacto.Campo_11); 
        this.formularioContacto.controls['Campo_12'].setValue(this.dataContacto.Campo_12); 
        this.formularioContacto.controls['Campo_13'].setValue(this.dataContacto.Campo_13); 
        this.formularioContacto.controls['Campo_14'].setValue(this.dataContacto.Campo_14); 
        this.formularioContacto.controls['Campo_15'].setValue(this.dataContacto.Campo_15); 
        this.formularioContacto.controls['Campo_16'].setValue(this.dataContacto.Campo_16); 
        this.formularioContacto.controls['Campo_17'].setValue(this.dataContacto.Campo_17); 
        this.formularioContacto.controls['Campo_18'].setValue(this.dataContacto.Campo_18); 
        this.formularioContacto.removeControl("Adjunto_DNI");
        this.formularioContacto.removeControl("Adjunto_Vigencia_Poder");
        this.formularioContacto.removeControl("Contrasena");
        this.formularioContacto.removeControl("Fecha_Contrasena");
        this.formularioContacto.removeControl("Fecha_Adjuntos");
        this.tipoDocumentoElement = this.dataContacto.Persona.Tipo_Documento_Identidad;
        this.rolContactoElement = this.dataContacto.Rol_del_Contacto;
        this.tipoContactoElement = this.dataContacto.Tipo_de_Contacto;
        
        this.loading = false;
        this.disable = true;

        },(err: HttpErrorResponse)=> {
          this.loading = false;
          this.msgStatus.getMessage(err.status);

          Swal.fire({
            title: this.msgTitulos.Error,
            text: "Contacto no obtenido. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        }
      );
    }
  }

  tipoDocumento(event){
    this.formularioContacto.controls['Tipo_Documento_Identidad'].setValue(event);
    this.validarTipoDoc(event);
  }

  rolContacto(event){
    this.formularioContacto.controls['Rol_del_Contacto'].setValue(event)
  }

  tipoContacto(event){
    this.formularioContacto.controls['Tipo_de_Contacto'].setValue(event)
  }

  crearContacto(){
    this.loading = true;
    this.formularioContacto.controls['Nombre_de_Contacto'].setValue( this.formularioContacto.controls['Apellido_Paterno'].value + ' ' +
    this.formularioContacto.controls['Apellido_Materno'].value + ', ' +
    this.formularioContacto.controls['Nombre1'].value + ' ' +
    this.formularioContacto.controls['Nombre2'].value);

    if(this.editar){
      this.empresasService.actualizarContacto(this.IdContacto, this.formularioContacto.getRawValue())
      .subscribe(res => {
          this.loading=false;
          Swal.fire({
            title: "¡Éxito!",
            text: 'Contacto modificado correctamente.',
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then( resp => {
            if (resp.value == true){
              this.loginService.clickGuard = true;
              this.refresh.emit();
              this.cerrarAgregarContacto.emit();
            }
          });
      },(err: HttpErrorResponse)=> {
        this.loading=false;
        this.msgStatus.getMessage(err.status); 
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "CONTACTO NO ACTUALIZADO. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      })
    }else{
      if(this.formularioContacto.get('Nro_Documento_Identidad').value == ""){
        this.formularioContacto.controls['Nro_Documento_Identidad'].setValue(99999999);
      }
      this.empresasService.agregarContacto(this.formularioContacto.getRawValue()).subscribe(
        res => {
          this.loading = false;
          if(this.formularioContacto.get('checkCreateUser').value == 1){
              //CREAR USUARIO
              let formUser = {
                'Nombre':this.formularioContacto.controls['Nombre1'].value+' '+this.formularioContacto.controls['Apellido_Paterno'].value,
                'Telefono':this.formularioContacto.controls['NroMovil_Laboral'].value,
                'Usuario':this.formularioContacto.controls['Nro_Documento_Identidad'].value,
                'Email':this.formularioContacto.controls['Correo'].value,
                'id_empresa':'4',
                'Password':this.formularioContacto.controls['Nro_Documento_Identidad'].value,
                'NombreProyecto':'Extranet',
                'Host':'EXTRANET',
                'IP':'0',
                'Canal':'W',
              }
              
              this.loginService.createUsuario(formUser).subscribe(
                res2 => {
                  let data2:any = res2;
                  let formActivate = { 
                    'usuario':data2.Usuario, 
                    'id_empresa':'4',
                    'ruc':data2.Usuario,
                    'NombreProyecto':'Extranet', 
                  }
                  
                  let formAccess = { 
                    'id_user':data2.id_user, 
                    'id_sistemas':'2', 
                    'id_roles':80, 
                    'Ruta':'-', 
                    'id_empresa':'4',
                    'ruc':data2.Usuario,
                    'Usuario':'robot',
                    'NombreProyecto':'Extranet', 
                    'Host':'Extranet',  
                    'IP':'0',  
                    'Canal':'W', 
                  }
                  this.securityService.RegistrarAcceso(formAccess).subscribe(
                    res4 => {
                      this.loginService.generarCodigoActivacion(formActivate).subscribe(
                        res3 => {
                          let data3 = res3;
                          this.showNotification('success', 'top', 'right', 'Usuario de extranet creado con éxito.');
                      
                        }
                      );               
                    }
                  );
                  
                }
              );
              //FIN CREAR USUARIO
          }          

          Swal.fire({
            title: "¡Éxito!",
            text: 'Contacto registrado correctamente.',
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then( respu => {
            if (respu.value == true){
              this.loginService.clickGuard = true;
              this.refresh.emit();
              this.cerrarAgregarContacto.emit();
            }
          });
      },(err: HttpErrorResponse)=> {
        this.loading=false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Contacto no registrado. "+this.msgStatus.message,
          type: "error",
          footer:"<span>"+err.error.error+"</span>",
          allowOutsideClick: true,
          heightAuto: false
        })
      })
    }    
  }

  validarTipoDoc(valor: any){
    if(this.doc == '1' && valor == this.Id_Carnet){
      this.formularioContacto.controls['Tipo_Documento_Identidad'].enable();
      this.formularioContacto.controls['Nro_Documento_Identidad'].enable();
      this.formularioContacto.controls['Apellido_Paterno'].enable();
      this.formularioContacto.controls['Apellido_Materno'].enable();
      this.formularioContacto.controls['Nombre1'].enable();
      this.formularioContacto.controls['Nombre2'].enable();
      this.disable = false;
    }else{
      this.formularioContacto.controls['Tipo_Documento_Identidad'].enable();
      this.formularioContacto.controls['Nro_Documento_Identidad'].enable();
      this.formularioContacto.controls['Apellido_Paterno'].enable();
      this.formularioContacto.controls['Apellido_Materno'].enable();
      this.formularioContacto.controls['Nombre1'].enable();
      this.formularioContacto.controls['Nombre2'].enable();
      this.disable = false;
    }
  }

  validarDocumentoExiste(valor : any){
    if (this.doc == '1'){
      this.formularioContacto.controls['Tipo_Documento_Identidad'].enable();
      this.formularioContacto.controls['Nro_Documento_Identidad'].enable();
      this.formularioContacto.controls['Apellido_Paterno'].enable();
      this.formularioContacto.controls['Apellido_Materno'].enable();
      this.formularioContacto.controls['Nombre1'].enable();
      this.formularioContacto.controls['Nombre2'].enable();
      this.tipoDocumentoElement = 0;
      this.disable = false;
    }else{
      //this.formularioContacto.controls['Tipo_Documento_Identidad'].disable();
      //this.formularioContacto.controls['Nro_Documento_Identidad'].setValue(99999999);
      //this.formularioContacto.controls['Nro_Documento_Identidad'].disable();      
      this.formularioContacto.controls['Apellido_Paterno'].enable();
      this.formularioContacto.controls['Apellido_Materno'].enable();
      this.formularioContacto.controls['Nombre1'].enable();
      this.formularioContacto.controls['Nombre2'].enable();
      //this.disable = true;
      this.disable = false;
      this.tipoDocumentoElement = this.Id_Tipo_DNI;
      this.bodyObtenerPersona.NroDoc="";
      this.formularioContacto.controls['Tipo_Documento_Identidad'].setValue(this.Id_Tipo_DNI);

    }

  }

  asignarDatosPersona( persona : Persona){
    this.formularioContacto.controls['Apellido_Paterno'].setValue( persona.ApellidoPaterno);
    this.formularioContacto.controls['Apellido_Materno'].setValue(persona.ApellidoMaterno);
    this.formularioContacto.controls['Nombre1'].setValue(persona.PrimerNombre);
    this.formularioContacto.controls['Nombre2'].setValue(persona.SegundoNombre);  
    this.formularioContacto.controls['Direccion'].setValue(persona.Direccion);  
    this.formularioContacto.controls['Distrito'].setValue(persona.Distrito);  
  } 
  obtenerPersona(){
    if(this.bodyObtenerPersona.NroDoc == "") return;
    this.loading = true;
    if(this.formularioContacto.controls['Tipo_Documento_Identidad'].value == this.Id_Tipo_DNI){
        this.empresasService.obtenerPersonaRiesgo(this.bodyObtenerPersona)
              .subscribe( res => {
                  let rpta = res;
                  if(rpta["message"]){
                    Swal.fire({
                      title: "Error de búsqueda.",
                      text: rpta["message"],
                      type: "error",
                      allowOutsideClick: true,
                      heightAuto: false
                    });
                    this.loading = false; 
                  }
                  this.persona = res as Persona;
                  this.asignarDatosPersona(this.persona);
                  this.loading = false;
              },(err: HttpErrorResponse)=> {
                this.loading = false;
                if (err.error instanceof ErrorEvent) {
                  console.error("Error Event");
              } else {
                  this.msgStatus.getMessage(err.status);            
              }
                Swal.fire({
                  title: this.msgTitulos.Error,
                  text: "Datos no obtenidos. "+this.msgStatus.message ,
                  type: "error",
                  allowOutsideClick: true,
                  heightAuto: false
                })
              })
    }else{
      Swal.fire({
        title: "Atención.",
        text: "La búsqueda solo es para documentos tipo DNI.",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      this.loading = false;
    }
  }
  
  CerrarPopUp(){
    this.cerrarAgregarContacto.emit();
  }

  showNotification(type, from, align, message) {

    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}
